<!--  -->
<template>
    <div class='inquire'>
        <el-container>
            <el-header height='60px'>
                <HEAD step = '1'></HEAD>
            </el-header>
            <el-main>
                <div class="headS">
                    <img class="img" src="../assets/img/order.png" alt="">
                    <span class="query">
                        查询订单
                    </span>
                    <div class="inpu">
                        <el-input placeholder="搜索订单" v-model="indent">
                        </el-input>
                        <img class="search" src="../assets/img/fdj.png" alt="" @click="queryA">
                    </div>
                    <span class="wx">
                        <img src="../assets/img/wx.png" alt="">
                        <el-popover
                            placement="bottom"
                            width="560"
                            trigger="hover">
                            <img src="../assets/img/wxdd.png" alt="">
                            <el-button type="text" slot="reference">微信订单号？</el-button>
                        </el-popover>
                    </span>
                    <span class="zfb">
                        <img src="../assets/img/zfb.png" alt="">
                        <el-popover
                            placement="bottom"
                            width="560"
                            trigger="hover">
                            <img src="../assets/img/zfbdd.png" alt="">
                            <el-button type="text" slot="reference">支付宝订单号？</el-button>
                        </el-popover>
                    </span>
                </div>
                <div v-if="tableDatas.length>0">
                    <div class="message">
                        <div class="number">
                            <span>
                                订单编号:
                            </span>
                            <span>
                                {{oid}}
                            </span>
                        </div>
                        <div class="time">
                            <span>
                            成交时间：
                            </span>
                            <span>{{createdS}}</span>
                        </div>
                        <div class="relation">
                            <el-button type="text">
                                <a target="_blank" href="https://chaten.soboten.com/chat/pc/v2/index.html?sysnum=44471b4436844318a9299450b8eedcd4&channelid=21">
                                联系卖家
                                </a>
                                <img src="../assets/img/relation.png" alt="">
                            </el-button>
                        </div>
                    </div>
                    <div class="teble">
                        <el-table
                        :data="tableDatas"
                        :span-method="objectSpanMethod"
                        :cell-style = "cellStyle"
                        border
                        style="width: 100%;">
                            <el-table-column
                                label="打印文件名"
                                align="center"
                                width="395">
                                <template slot-scope="scope">
                                    <div style="text-align: left; margin-left: 30px">
                                        <img style="position: relative; top: 4px;" src="../assets/img/pdf3.png" alt="">
                                        <el-tooltip class="item" effect="dark" :content="scope.row.file_name" placement="top">
                                        <span style="margin-left: 2px; display: inline-block;position: relative; top: 8px;text-align: left;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" :style="{'max-width':MoreThan && tableData.length > 1 ? '53%':'80%'}" >{{ scope.row.file_name }}</span>
                                        </el-tooltip>
                                        <el-button type="text" v-if="MoreThan && tableData.length > 1" @click="particulars">
                                            <span style="color: #126eac; text-decoration: underline;">（含{{tableData.length}}份文件）详细</span>
                                        </el-button>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="price"
                                align="center"
                                label="价格">
                                <template slot-scope="scope">
                                    <span>
                                        {{ price(scope.row.price) }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="nums"
                                align="center"
                                label="数量">
                            </el-table-column>
                            <el-table-column
                                align="center"
                                width="180"
                                cell-class-name='fff'
                                label="实付款">
                                <template slot-scope="scope">
                                    <span style="font-size: 16px; color: #126eac; marginBottom: 10px;">
                                        ￥{{scope.row.practical.Amount}}
                                    </span>
                                    <div style="marginTop: 10px; color:#999;">
                                        <span>
                                            打印费用:￥{{scope.row.practical.print}}
                                        </span>
                                        <br>
                                        <span>
                                            邮寄费用:￥{{scope.row.practical.express}}
                                        </span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="odd"
                                width="356"
                                label="快递信息">
                                <template slot-scope="scope" style="color: #333;">
                                    <div style="padding: 0 30px;">
                                        <div style="textAlign: left;">
                                            <span style="color: #999;">{{scope.row.odd.expressage}}:</span> {{scope.row.odd.expressageId || '暂无'}} <el-button type="text" style="color: #126eac;padding: 0;" class="tag-read" :data-clipboard-text="scope.row.odd.expressageId" @click="copy">复制</el-button>
                                        </div>
                                        <div style="textAlign: left;">
                                            <span style="color: #999;">物流状态: </span>{{state[scope.row.odd.express_status] || '未发货'}}
                                        </div>
                                        <div style="textAlign: left;">
                                            <div style="color: #999;float: left;">收货信息: </div>
                                            <div style="width: 76%;float: left;margin-left:6px">
                                                <div>
                                                    {{scope.row.odd.name}} , {{scope.row.odd.number}} 
                                                </div>
                                                <div>
                                                    {{scope.row.odd.site}}
                                                </div>
                                            </div>

                                        </div>
                                        <!-- <div style="textAlign: left; marginLeft: 63px">
                                            {{scope.row.odd.site}}
                                        </div> -->
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div v-else class="stateless">
                    <el-empty :image="notHave" description="没有查询出订单！">
                        <el-button class="submit" type="primary" @click="submit">提交打印</el-button>
                        <p>温馨提示: 请确认输入订单编号正确或已成功提交打印，如有疑问请联系在线客服。</p>
                    </el-empty>
                </div>
                <div class="fiexBox">
                  <div class="kefu" @click="openKf">联系客服</div>
                  <div class="shouchang" @click="addFavorite">收藏页面</div>
                </div>
            </el-main>
            <el-footer>
                {{FOOTER}}
            </el-footer>
        </el-container>
    </div>
</template>

<script>
import head from '../components/head.vue';
import Clipboard from 'clipboard';
import common from '../commons/common';
export default {
    components: {
        HEAD: head,
    },
    data () {
        return {
			FOOTER: common.FOOTER,
            toDecimal2:  common.toDecimal2,
            indent: '',// 订单
            MoreThan: true, // 是否显示文件详情
            notHave: require("../assets/img/notHave.png"),
            tableDatas: [],
            tableData: [],
            createdS: '', // 时间
            oid: '', // 订单号
            state: [ // 物流状态，
                 "待发货",
                 "已发货",
                 "待揽收",
                 "已揽收",
                 "运输中",
                 "派件中",
                 "已代签收",
                 "已签收",
                 "物流异常"
            ]
        };
    },
    created() {
        if(this.$route.query.oid) { // 第一次使用路由传值,防止存储异步
            this.indent = this.$route.query.oid
            this.queryA()
        }else if(localStorage.getItem('oid')){ // 刷新使用本地存储
            if(localStorage.getItem('time') && new Date().getTime() - localStorage.getItem('time')>=172800000) {
                localStorage.removeItem('time')
                localStorage.removeItem('oid')
            }else {
                this.indent = localStorage.getItem('oid')
                this.queryA()
            }
        }
    },
    methods: {
        price(e) {
            let price = e*0.01
            price =  Math.floor(price * 100) / 100
            return price
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex > 2) {
            if (rowIndex === 0) {
                return {
                rowspan: 1000,
                colspan: 1
                };
            } else {
                return {
                rowspan: 0,
                colspan: 0
                };
            }
            }
        },
         // 单元格的 style 的回调方法
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (columnIndex >2) {
                if (rowIndex === 0) {
                    return `background-color: #fff;`;
                } else {
                    return ''
                }
            }
        },
        particulars() {
            this.MoreThan = false
            this.tableDatas = this.tableData
        },
        submit() { // 提交打印
            this.$router.push('/')
        },
        copy () {
            var clipboard = new Clipboard('.tag-read')
            clipboard.on('success', e => {
                this.$message({
                    message: '复制成功',
                    type: 'success'
                });
                //  释放内存
                 clipboard.destroy()
            })
                clipboard.on('error', e =>{
                // 不支持复制
                this.$message.error('复制失败');
                // 释放内存
                 clipboard.destroy()
            })
        },
      queryA() {
            if(!this.indent){
                this.$message({
                    message: '输入订单后查询信息',
                    type: 'warning'
                });
                return
            } 
          this.Api.query(this.indent)
          .then((res) => {
            this.tableDatas = []
            this.tableData = []
            let tableItem = []
            if(res.data.code == -1){
              this.$message.error(res.data.codeMsg || '错误');
            }
            if(res.data.code == 200){
                this.MoreThan = true
                let tableData = res.data.data
                this.oid = tableData.oid
                this.createdS = tableData.created
                tableItem.push(tableData.file_detail[0])

                let a = tableData.pay_money-tableData.data.shipping
                a =  a.toFixed(2)
                tableItem[0].practical = {
                    Amount: this.toDecimal2(tableData.pay_money),
                    print: this.toDecimal2(a),
                    express: this.toDecimal2(tableData.data.shipping)
                }
                tableItem[0].odd = {
                    expressage: '快递单号',
                    expressageId: tableData.express_no,
                    express_status: tableData.express_status,
                    name: tableData.data.receive_name,
                    number: tableData.data.receive_mobi,
                    site: tableData.data.receive_addr
                }
                this.tableData = tableData.file_detail
                this.tableData[0] = JSON.parse(JSON.stringify(tableItem[0]))

                let price = 0
                let nums = 0
                for(let i=0; i<tableData.file_detail.length; i++) {
                   price = price + tableData.file_detail[i].price
                   nums = nums + Number(tableData.file_detail[i].nums)
                }
                this.tableDatas = tableItem
                this.tableDatas[0].price = price
                this.tableDatas[0].nums = nums
            }
          })
          .catch((err) => {
            this.$message.error('当前无网络')
          })
      },
      openKf(){
        window.open(common.urlKEFU)
      },
      addFavorite(){
		common.addFavorite(this)
      },
    },
}
</script>

<style lang='less' scoped>
    .inquire {
        background-color: #f8f8f8;
        height: 100%;
    }
    .el-header {
        background-color: #fff;
    }
    .el-container {
        height: 100%;
    }
    .el-main {
        max-width: 1250px;
        width: 100%;
        height: 80%;
        background-color: #fff;
        margin: 16px auto 0;
        padding: 0;
        position: relative;
        overflow: visible;
        .fiexBox {
          position: absolute;
          top: 240px;
          right: -63px;
        }
        .kefu,.shouchang {
          width: 43px;
          height: 43px;
          border: 1px solid #e7e7e7;
          background: #fff;
          color: #9e9e9e;
          font-size: 12px;
          padding: 4px;
          box-sizing: border-box;
          text-align: center;
          cursor: pointer;
          &:hover{
            background: #0d81fc;
            color: #fff;
          }
        }
        .shouchang{
          margin-top: 10px;
        }
        .headS {
            min-height: 97px;
            overflow: hidden;
            line-height: 97px;
            background: linear-gradient(
        45deg, #f8faff, #f0f5ff);
            position: relative;
            border: 1px transparent solid;
            border-image: linear-gradient(to right, #f3f7ff, #e2edfd) 1 10;
            position: relative;
            .img {
                position: absolute;
                right: 0;
                top: 0;
            }
            .query , .wx , .zfb {
                float: left;
                color: #666666;
            }
            .query {
                margin: 0 27px;
                color: #000;
            }
            .wx {
                margin-left: 50px;
                margin-right: 20px;
            }
            .zfb , .wx {
                img {
                    position: relative;
                    top: 4px;
                }
            }
            .inpu {
                float: left;
                position: relative;
                width: 423px;
                height: 35px;
                margin-top: 28px;
                line-height: 0;
                img {
                    position: absolute;
                    right: 15px;
                    top: 14px;
                }
              .search{
                cursor: pointer;
              }
            }
            .el-input {
                background-color: #ffffff;
                border-radius: 4px;
                border: solid 1px #f4f4f4;
            }
        }
        .message {
            height: 55px;
            line-height: 55px;
            div {
                float: left;
                color: #999999;
                font-size: 12px;
            }
            .number {
                margin-left: 23px;
                margin-right: 172px;
            }
            .relation {
                float: right;
                margin-right: 24px;
                a {
                    color: #126eac;
                    text-decoration: none;
                }
                img {
                    position: relative;
                    top:6px;
                }
            }
        }
        .teble {
            width: 96%;
            margin: auto;
            /deep/th {
                background-color: #f4f5fa !important;
            }
        }
        /deep/.el-table_1_column_4, /deep/.el-table_1_column_5 {
            background-color: #fff !important;
        }
    }
    .el-footer {
        text-align: center;
        line-height: 60px;
        color: #bebebe;
        font-size: 12px;
    }
    .stateless {
        margin-top: 10%;
        p {
            font-size: 12px;
            color: #bcbcbc;
            margin-top: 20px;
        }
    }
    .submit {
        width: 120px;
        background-color: #126eac;
        border-radius: 4px;
        border: 0;
    }
    @media (max-width: 1400px){
        .fiexBox{
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/inquire.vue